/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VaultSearchResult,
    VaultSearchResultFromJSON,
    VaultSearchResultFromJSONTyped,
    VaultSearchResultToJSON,
} from './';

/**
 * 
 * @export
 * @interface VaultSearchResponse
 */
export interface VaultSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof VaultSearchResponse
     */
    totalResults?: number;
    /**
     * 
     * @type {Array<VaultSearchResult>}
     * @memberof VaultSearchResponse
     */
    results?: Array<VaultSearchResult> | null;
}

export function VaultSearchResponseFromJSON(json: any): VaultSearchResponse {
    return VaultSearchResponseFromJSONTyped(json, false);
}

export function VaultSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VaultSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalResults': !exists(json, 'totalResults') ? undefined : json['totalResults'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(VaultSearchResultFromJSON)),
    };
}

export function VaultSearchResponseToJSON(value?: VaultSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalResults': value.totalResults,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(VaultSearchResultToJSON)),
    };
}


